import {ref, reactive} from 'vue';
import revenuemanagementService from '@services/revenuemanagementService';

export const PERFORMANCE_KEYS = [
  // Finance
  'BUSINESS_VOLUME',
  'AVERAGE_NIGHT_PRICE',
  'REVPAR',
  'HOST_REVENUE',
  'CANCELLATION_BUSINESS_VOLUME',

  // Occupation
  'GUEST_OCCUPANCY_RATE',
  'RENTED_NIGHTS',
  'OCCUPANCY_RATE',
  'CLOSURE_RATE',
  'UNAVAILABLE_NIGHTS',
  'AVAILABLE_NIGHTS',

  // Reservations
  'RESERVATION_COUNT',
  'AVERAGE_STAY_DURATION',
  'AVERAGE_BOOKING_WINDOW',
  'CANCELLATION_COUNT',
  'AVERAGE_CANCELLATION_WINDOW',
  'PLATFORM_DISTRIBUTION',
];

export const QUALITY_KEYS = [
  // Rating
  'REVIEW_COUNT',
  'GLOBAL_RATING',
  'GUESTADOM_RATING',
  'AIRBNB_RATING',
  'BOOKING_RATING',
  'ABRITEL_RATING',
  'PAP_RATING',
  'HOLIDU_RATING',
];

export const INDICATOR_KEYS = [...PERFORMANCE_KEYS, ...QUALITY_KEYS];

export function useDashboard() {
  // --- État global du prepare ---
  const isPreparing = ref(false);
  const prepareError = ref(null);
  // --- État par indicateur ---
  const indicators = reactive(Object.fromEntries(INDICATOR_KEYS.map((k) => [k, null])));
  const indicatorsLoading = reactive(Object.fromEntries(INDICATOR_KEYS.map((k) => [k, false])));
  const indicatorsError = reactive(Object.fromEntries(INDICATOR_KEYS.map((k) => [k, null])));
  // --- Appelé par le bouton "Rechercher" du parent ---
  const fetchDashboard = async (filters, group) => {
    // Reset complet
    isPreparing.value = true;
    prepareError.value = null;

    let keysToFetch;
    if (group === 'quality') {
      keysToFetch = QUALITY_KEYS;
    } else if (group === 'performances') {
      keysToFetch = PERFORMANCE_KEYS;
    } else {
      keysToFetch = INDICATOR_KEYS;
    }

    keysToFetch.forEach((key) => {
      indicators[key] = null;
      indicatorsLoading[key] = false;
      indicatorsError[key] = null;
    });
    // Étape 1 : prepare (chargement transverse + cache UUID)
    let uuid;
    try {
      uuid = await revenuemanagementService.prepare(filters);
    } catch (e) {
      prepareError.value = e;
      isPreparing.value = false;
      return;
    }
    isPreparing.value = false;
    // Étape 2 : 25 appels parallèles, chacun gère son propre état
    keysToFetch.forEach((key) => {
      indicatorsLoading[key] = true;
      revenuemanagementService
        .indicator(uuid, key)
        .then((data) => {
          indicators[key] = {...data, uuid: uuid, key: key};
        })
        .catch((e) => {
          indicatorsError[key] = e;
        })
        .finally(() => {
          indicatorsLoading[key] = false;
        });
    });
  };
  return {isPreparing, prepareError, indicators, indicatorsLoading, indicatorsError, fetchDashboard};
}
